import { Oferta } from '../../types/oferta-types';
import { CarlineWithOfertas } from '../../types/vehicle-types';
import { externalContentManager } from '../external-content';
import { fetchDataOfertas } from './fetch/data-fetch';

export const getCarlineOfertas = async (): Promise<CarlineWithOfertas[] | null> => {
	const response = await fetchDataOfertas();

	if (response) {
		return response;
	}
	return null;
};

export const getOfertaById = async (ofertaId: number): Promise<any | null> => {
	const response = await fetchDataOfertas();
	if (response) {
		for (const carline of response) {
			const oferta = carline.ofertas?.find((oferta: Oferta) => oferta.id == ofertaId);
			if (oferta) return { carline, oferta };
		}
	}
	return null;
};

// Obtiene la oferta desde ofertaId
export const getOferta = async (): Promise<any | null> => {
	const ofertaId = externalContentManager.ofertaId;

	if (ofertaId) {
		const result = await getOfertaById(Number(ofertaId));
		if (result?.carline && result?.oferta) {
			return { carline: result.carline, oferta: result.oferta };
		}
	}
	return null;
};

export const getSortedDatosEconomicos = (oferta: Oferta | undefined) => {
	if (!oferta?.datosEconomicos) return [];

	return oferta.datosEconomicos.sort((a, b) => b.prioridad - a.prioridad).slice(0, 2);
};
